import { StripeElementLocale } from '@stripe/stripe-js';

import { AppLocale } from '@app/i18n';

/**
 * Maps app locale codes to Stripe-supported locale codes
 * @param appLocale The app's locale (e.g., 'es', 'fr', 'en')
 * @returns Stripe locale code (e.g., 'es', 'fr', 'en')
 */
export const mapAppLocaleToStripeLocale = (appLocale: AppLocale | string): StripeElementLocale => {
  switch (appLocale) {
    case AppLocale.es:
      return 'es';
    case AppLocale.fr:
      return 'fr';
    case AppLocale.en:
    default:
      return 'en';
  }
};
